<template>
	<div class="batch-import-task-page page-layout">
		<gc-header headerData="omPlatformInformation">
			<template #ops>
				<el-button
					v-has="'monitor:imei:platform:product:insert'"
					type="primary"
					@click="
						selectFormValues = null
						platformModalVisible = true
					"
				>
					新增运营商平台
				</el-button>
			</template>
		</gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleQuerySearch"
					@reset="handleQueryReset"
				/>
				<gc-column-setting
					storageKey="localcolumn-om-platform-information"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show" v-loading="loading">
				<gc-table
					border
					showPage
					:columns="columnList"
					:table-data="tableData"
					:current-page.sync="pagination.currentPage"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					@current-page-change="handleCurrentPageChange"
					@size-change="handlePageSizeChange"
				></gc-table>
			</div>
		</div>
		<OperatePlaformModal
			v-if="platformModalVisible"
			:formValues="selectFormValues"
			@close-modal="handleCloseModal"
		/>
	</div>
</template>

<script>
import {
	apiGetPlatformProductPageList,
	apiDeletePlatformProduct,
	apiUpdatePlatformProduct,
} from '@/apis/communicationModelManage.api'
import OperatePlaformModal from './components/OperatePlaformModal'

export default {
	name: 'omPlatformInformation',
	components: { OperatePlaformModal },
	data() {
		return {
			form: {
				platformName: null,
				platformType: null,
			},
			columns: [
				{
					key: 'platformName',
					name: '平台名称',
					tooltip: true,
					dragDisable: true,
					disabledSelect: true,
				},
				{
					key: 'platformType',
					name: '运营商',
				},
				{
					key: 'publicFlag',
					name: '权限控制',
					render: (h, row) => {
						return h('span', null, row.publicFlag === 1 ? '公开' : '私有')
					},
				},
				{
					key: 'status',
					name: '状态',
					render: (h, row) => {
						return h(
							'span',
							{ class: row.status === 0 ? 'dot-error' : 'dot-success' },
							row.status === 0 ? '禁用' : '启用',
						)
					},
				},
				{
					key: 'createdTime',
					name: '创建时间',
					width: 180,
				},
				{
					key: 'createStaffName',
					name: '创建人',
				},
				{
					key: 'remarks',
					name: '备注',
					tooltip: true,
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 240,
					render: (h, row) => {
						return h(
							'div',
							null,
							[
								row.manufacturerId === this.manufacturerId &&
								this.$has('monitor:imei:platform:product:update')
									? h(
											'el-button',
											{
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleOperate(row, 'update'),
												},
											},
											'修改',
									  )
									: null,
								row.manufacturerId === this.manufacturerId &&
								row.status === 1 &&
								this.$has('monitor:imei:platform:product:update')
									? h(
											'el-button',
											{
												style: { color: '#e5662e' },
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleOperate(row, 'status'),
												},
											},
											'禁用',
									  )
									: null,
								row.manufacturerId === this.manufacturerId &&
								row.status === 0 &&
								this.$has('monitor:imei:platform:product:update')
									? h(
											'el-button',
											{
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleOperate(row, 'status'),
												},
											},
											'启用',
									  )
									: null,
								row.manufacturerId === this.manufacturerId &&
								this.$has('monitor:imei:platform:product:delete')
									? h(
											'el-button',
											{
												style: { color: '#e5662e' },
												props: { type: 'text', size: 'medium' },
												on: {
													click: () => this.handleOperate(row, 'delete'),
												},
											},
											'删除',
									  )
									: null,
								h(
									'el-button',
									{
										props: { type: 'text', size: 'medium' },
										on: {
											click: () => this.handleOperate(row, 'detail'),
										},
									},
									'详情',
								),
							].filter(Boolean),
						)
					},
				},
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
			platformModalVisible: false,
			selectFormValues: null,
		}
	},

	created() {
		this.queryTableDataPageList()
	},

	methods: {
		async queryTableDataPageList() {
			this.loading = true
			const searchParams = {
				...this.form,
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
				manufacturerId: this.manufacturerId,
			}
			try {
				const { records = [], total } = await apiGetPlatformProductPageList(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleOperate(rowItem, type) {
			if (type === 'detail') {
				this.$router.push({
					path: '/communication-model-manage/om-platform-information/details',
					query: {
						platformId: rowItem.platformId,
					},
				})
			} else if (type === 'delete') {
				this.handleDeletePlatformProduct(rowItem)
			} else if (type === 'status') {
				this.handleUpdatePlatformProductStatus({ ...rowItem, status: rowItem.status === 1 ? 0 : 1 })
			} else if (type === 'update') {
				this.selectFormValues = rowItem
				this.platformModalVisible = true
			}
		},

		/**
		 * 运营商平台状态变更
		 * @param {*} param0
		 */
		async handleUpdatePlatformProductStatus({ platformId, manufacturerId, status }) {
			await this.$confirm(status === 1 ? '确认启用该运营商平台？' : '确认禁用该运营商平台？')
			await apiUpdatePlatformProduct({ platformId, manufacturerId, status })
			this.$message.success('操作成功')
			this.handleQueryReset()
		},

		/**
		 * 运营商平台删除
		 * @param {*} param0
		 */
		async handleDeletePlatformProduct({ platformId, manufacturerId }) {
			await this.$confirm('你确定要删除该运营商平台，删除后不可撤销，请确认！')
			await apiDeletePlatformProduct({ platformId, manufacturerId })
			this.$message.success('操作成功')
			this.handleQueryReset()
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},

		handlePageSizeChange(size) {
			this.pagination.currentPage = 1
			this.pagination.pageSize = size
			this.queryTableDataPageList()
		},

		handleQuerySearch() {
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		handleQueryReset() {
			for (const key in this.form) {
				this.form[key] = null
			}
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},

		handleCloseModal(refresh) {
			this.platformModalVisible = false
			if (refresh) {
				this.handleQueryReset()
			}
		},
	},

	computed: {
		columnList() {
			return this.columns.filter(o => o.selected)
		},

		tenantId() {
			return this.$store.getters.userInfo.tenantId || null
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},

		platformTypeOptions() {
			return (this.$store.getters.dataList?.platformType || []).map(m => {
				return {
					label: m.name,
					value: m.defaultValue,
				}
			})
		},

		filterFields() {
			return [
				{
					prop: 'platformName',
					label: '平台名称',
					type: 'input',
				},
				{
					prop: 'platformType',
					label: '运营商',
					type: 'select',
					props: {
						searchOption: this.platformTypeOptions,
						needAllForSearch: true,
					},
				},
			]
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
</style>
